import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function VideoModal({ video, onClose }) {
  return (
    <AnimatePresence>
      {video && (
        <motion.div
          data-testid="video-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-ink/90 backdrop-blur-md p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.92, y: 24 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.94, y: 16 }}
            transition={{ type: "spring", stiffness: 260, damping: 26 }}
            className={`relative w-full ${video.ratio === "9/16" ? "max-w-sm" : "max-w-4xl"}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="video-modal-close-button"
              onClick={onClose}
              className="absolute -top-11 right-0 flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-slate-300 hover:text-glow transition-colors"
            >
              Kapat <X size={18} />
            </button>
            <p className="mb-3 font-syne text-sm sm:text-base font-semibold text-slate-100">{video.title}</p>
            <div className="overflow-hidden rounded-xl border border-white/10 shadow-[0_0_80px_-20px_rgba(6,182,212,0.4)]">
              <video
                src={video.videoUrl}
                controls
                autoPlay
                playsInline
                className="w-full h-auto bg-black"
                style={{ aspectRatio: video.ratio }}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
